"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressesIds = exports.getAddressesMap = exports.getAddresses = exports.getIsAddressesLoaded = exports.getIsAddressesLoading = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _address = require("./address.reducer");

var getAddressState = function getAddressState(state) {
  return state.createGift.address;
};

var selectors = _address.addressAdapter.getSelectors(getAddressState);

var getIsAddressesLoading = (0, _ramda.pipe)(getAddressState, (0, _ramda.propEq)('status', _utils.StateStatus.Pending));
exports.getIsAddressesLoading = getIsAddressesLoading;
var getIsAddressesLoaded = (0, _ramda.pipe)(getAddressState, (0, _ramda.propEq)('status', _utils.StateStatus.Fulfilled));
exports.getIsAddressesLoaded = getIsAddressesLoaded;
var getAddresses = selectors.getAll;
exports.getAddresses = getAddresses;
var getAddressesMap = selectors.getEntities;
exports.getAddressesMap = getAddressesMap;
var getAddressesIds = selectors.getIds;
exports.getAddressesIds = getAddressesIds;